export default __webpack_public_path__ + "media/129cb79d2654bce83bf390935dba11a74fc0a447a7e72c1755ec38a5053f1a82.svg";